(function FitBuilderTemplates($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function onReady()
	{
		var template_component_details_pages = [
			'FitBuilderTemplates/cloneTemplate',
			'FitBuilderTemplates/createTripSummary',
			'FitBuilderTemplates/viewComponents',
		];

		// table sorting for trip summary templates
		Adzuki.onload(['FitBuilderTemplates/index'], function onload()
		{
			var $active_templates    = $('#active-templates');
			var $franchise_templates = $('#franchise-templates');
			var $archived_templates  = $('#archived-templates');

			// active fit builder templates
			Adzuki.Ajax.get('/FitBuilderTemplates/getTemplates/active')
				.then(function populateAgentTemplates(response) {
					$active_templates.html(response);
					Adzuki.TableSorter.initAjax($active_templates);
				}
			);

			// franchise shared fit builder templates
			Adzuki.Ajax.get('/FitBuilderTemplates/getTemplates/franchise')
				.then(function populateFranchiseTemplates(response) {
					$franchise_templates.html(response);
					Adzuki.TableSorter.initAjax($franchise_templates);
				}
			);

			// archived fit builder templates
			Adzuki.Ajax.get('/FitBuilderTemplates/getTemplates/archived')
				.then(function populateArchivedTemplates(response) {
					$archived_templates.html(response);
					Adzuki.TableSorter.initAjax($archived_templates);
				}
			);

			// init table sort when navigating to a different page
			$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
				Adzuki.TableSorter.initAjax($active_templates);
				Adzuki.TableSorter.initAjax($franchise_templates);
				Adzuki.TableSorter.initAjax($archived_templates);
			});
		});

		Adzuki.onload(template_component_details_pages, function onload()
		{
			$('.template-components').on('click', '.component-details', function showComponentDetails(e)
			{
				var day_number       = $(this).data('day_number'),
					component_number = $(this).data('component_number'),
					component_id     = $(this).data('component_id');

				e.preventDefault();

				$modal.find('.modal-body').text('Loading template component details...');
				$modal.find('.modal-title').text('DAY ' + day_number + ' COMPONENT ' + component_number + ' DETAILS');
				$modal.modal('show');

				Adzuki.Ajax.get('/FitBuilderTemplates/componentDetails/' + component_id)
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
